// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NiGM","name":"Header_name__tcytE","birthday":"Header_birthday__2sARB","skeleton":"Header_skeleton__37FRp"};